import $ from 'jquery';

import './index.scss';
import './about.css';
import './projects.css';
import './games.css';

class Portfolio {
  constructor() {
    this.doubleClick = true;
    this.clicked = false;
    this.slideIndex = 1;
  }
  init() {
    //nav
    $(
      '#webapps, #contact_contents, #game_vid_nw, #game_vid_sv, #game_vid_sp, #game_vid_wow' // eslint-disable-line
    ).hide();

    $('#myNumberInput').css({
      opacity: '0',
      height: '0px',
      width: '0px'
    });

    $('footer').html(`Copyright &copy; ${new Date().getFullYear()} Olayinka`);

    $('#contact').click(() => {
      this.enter();
    });
    $('#contact').mouseleave(() => {
      this.exit();
    });

    $('#copy_phone').click(() => {
      this.executeCopy();
    });

    //portfolio
    $('#pro_tabC11').click(event => {
      $('#pro_tabC11 .transArrow').css('transform', 'rotate(0deg)');
      $('#pro_tabJS .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabPython .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabBlogs .transArrow').css('transform', 'rotate(-90deg)');

      if ($('#pro_tabC11').hasClass('active')) {
        this.closeProjects('pro_tabJS', 'pro_C11');
      } else {
        this.revealProjects(event, 'pro_C11');
      }
    });

    $('#pro_tabJS').click(event => {
      $('#pro_tabJS .transArrow').css('transform', 'rotate(0deg)');
      $('#pro_tabC11 .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabPython .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabBlogs .transArrow').css('transform', 'rotate(-90deg)');

      if ($('#pro_tabJS').hasClass('active')) {
        this.closeProjects('pro_tabJS', 'pro_JS');
      } else {
        this.revealProjects(event, 'pro_JS');
      }
    });

    $('#pro_tabPython').click(event => {
      $('#pro_tabPython .transArrow').css('transform', 'rotate(0deg)');
      $('#pro_tabC11 .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabJS .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabBlogs .transArrow').css('transform', 'rotate(-90deg)');
      if ($('#pro_tabPython').hasClass('active')) {
        this.closeProjects('pro_tabPython', 'pro_python');
      } else {
        this.revealProjects(event, 'pro_python');
      }
    });
    $('#pro_tabBlogs').click(event => {
      $('#pro_tabBlogs .transArrow').css('transform', 'rotate(0deg)');
      $('#pro_tabC11 .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabJS .transArrow').css('transform', 'rotate(-90deg)');
      $('#pro_tabPython .transArrow').css('transform', 'rotate(-90deg)');

      if ($('#pro_tabBlogs').hasClass('active')) {
        this.closeProjects('pro_tabBlogs', 'pro_blogs');
      } else {
        this.revealProjects(event, 'pro_blogs');
      }
      this.displayMedium();
    });
    //games Page
    //social
    $('#twitter').click(function() {
      window.open('https://twitter.com/tinker_yenca', '_blank');
    });

    $('#git').click(function() {
      window.open('https://github.com/olayenca', '_blank');
    });

    $('#linkedin').click(function() {
      window.open('https://www.linkedin.com/in/olayinka-otuniyi/', '_blank');
    });
    $('#insta').click('on', function() {
      window.open('https://www.instagram.com/tinker_yenca/', '_blank');
    });

    $('#switch').click('on', function() {
      if (this.clicked) {
        $('#webapps').slideUp('slow');
        this.clicked = false;
      } else {
        $('#webapps').slideDown('slow');
        this.clicked = true;
      }
    });

    $('#react').click('on', function() {
      window.open('/react.index.html#/home', '_self');
    });

    $('#game_button_nw').click(() => {
      this.switches('#game_img_nw', '#game_vid_nw');
    });

    $('#game_button_sv').click(() => {
      this.switches('#game_img_sv', '#game_vid_sv');
    });

    $('#game_button_sp').click(() => {
      this.switches('#game_img_sp', '#game_vid_sp');
    });

    $('#game_button_wow').click(() => {
      this.switches('#game_img_wow', '#game_vid_wow');
    });
    //Footer social Portfolio

    $('#pro_all_projects').click(function() {
      window.open('https://github.com/olayenca', '_blank');
    });

    //social gaming

    $('#game_twitch').click(() => {
      window.open('https://www.twitch.tv/olayenca', '_blank');
    });

    $('#game_youtube').click(() => {
      window.open(
        'https://www.youtube.com/channel/UCjIuNL4Fq9IHaSBwHsBsg4A',
        '_blank'
      );
    });
   if ( $('#pro_page_portfolio').length) {
      this.showSlides(this.slideIndex, 'mainSlides', 'dotMain');
          this.showSlides(this.slideIndex, 'slidesWind', 'dotWind');
          this.showSlides(this.slideIndex, 'slidesDAQ', 'dotDAQ');
          this.showSlides(this.slideIndex, 'slidesLit', 'dotLit');
          this.showSlides(this.slideIndex, 'slidesV3', 'dotV3');
          this.showSlides(this.slideIndex, 'slidesSprit', 'dotSprit');
          this.showSlides(this.slideIndex, 'slidesTic', 'dotTic')
    }
  }
  pauseVideo() {
    $('.video-stream').length &&
      document.getElementsByClassName('video-stream')[0].pause();
  }

  enter() {
    $('#contact_contents').slideDown('slow');
  }
  exit() {
    $('#contact_contents').slideUp('slow');
  }
  executeCopy() {
    const copyNumber = document.getElementById('number');
    copyNumber.focus();
    copyNumber.select();
    document.execCommand('Copy');
    alert('Yinka\'s mobile has been copied to clipboard: ' + copyNumber.value);
  }
  closeProjects(tabID, contentID) {
    $(`#${tabID}`).removeClass('active');
    document.getElementById(contentID).style.display = 'none';
    $(`#${tabID} .transArrow`).css('transform', 'rotate(-90deg)');
    $('#pro_contents').show();
  }
  revealProjects(evt, tabID) {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName('tabcontent');
    tablinks = document.getElementsByClassName('tablinks');
    let $jumbo = $('#pro_contents');

    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '');
    }
    document.getElementById(tabID).style.display = 'inline-block';
    evt.currentTarget.className += ' active';
    $jumbo.hide();
  }
  switches(img_ID, vid_ID) {
    if (this.doubleClick === true) {
      $(img_ID).hide();
      $(vid_ID).show(() => {
        $(this).fadeIn(1000);
      });
      this.doubleClick = false;
    } else {
      this.pauseVideo();
      $(vid_ID).hide();
      $(img_ID).show(() => {
        $(this).fadeIn(1000);
      });
      this.doubleClick = true;
    }
  }
  displayMedium() {
    fetch(
      'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@olayenca'
    )
      .then(res => res.json())
      .then(data => {
        data.items.forEach((item, index) => {
          !$(`#post${index}`).length &&
            $('#medium-posts')
              .append(`<h3 
id="post${index}" 
class="medium-title col-sm-6"
>
${item.title}
</h3>
                            <div 
                            class='sideByside' 
                            style="border-bottom:1px solid gainsboro;"
                            >
                            <div class="col-sm-6">
                              <img 
                              style="height:36vmin;width:36vmin;object-fit:contain;" 
                              src='${item.thumbnail}'
                              />
                            </div>  
                             <div class="slideshow-container">
                              <div 
                              style="width:100vw;" 
                              class="col-sm-6"
                              >
                                ${item.content}
                              </div>
                             </div> 
                            </div>`);
        });
      });
  }

  plusSlides(n, sId, sDots) {
    this.showSlides((this.slideIndex += n), sId, sDots);
  }

  currentSlide(n, sId, sDots) {
    this.showSlides((this.slideIndex = n), sId, sDots);
  }

  showSlides(n, sId, sDots) {
    var i,
      slides = document.getElementsByClassName(sId),
      dots = document.getElementsByClassName(sDots);
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none';
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className =
          dots[i].className.replace(' active', '');
    }
    slides[this.slideIndex - 1].style.display = 'block';
    dots[this.slideIndex - 1].className += ' active';
  }
}
new Portfolio().init();
